import { Team, User } from '@run-diffusion/shared';

// Plugins & APIs beta feedback form (monday.com). No query string here — every
// param (including `r`) is set via URL.searchParams below.
const PLUGINS_FEEDBACK_FORM_BASE_URL: string = 'https://forms.monday.com/forms/fa846242e74e7d7d671bbb34afce7563';

/**
 * Builds the plugin feedback form URL (monday.com) with the current user +
 * company/team context appended so the form opens prefilled.
 */
export const buildPluginsFeedbackFormUrl = (
	user: User,
	team: Team,
): string => {
	const url: URL = new URL(PLUGINS_FEEDBACK_FORM_BASE_URL);
	// monday.com region-routing param (`use1` = US East 1) baked into the form's
	// share link — it points the form at the right regional backend, so keep it.
	url.searchParams.set('r', 'use1');
	url.searchParams.set('email', user?.email || '');
	url.searchParams.set('company', team?.company?.name || 'None');
	url.searchParams.set('team', team?.name || 'None');
	return url.toString();
};
